import { Component, Input } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { SelectFilter } from '@app/modules/table/classes/table-filters/select-filter.class';

// A global context used for naming the HTML input element of this component, to prevent collisions
// with other elements.
let nextContext = 0;

@Component({
    selector: 'app-table-select-filter',
    templateUrl: './select-filter.template.html',
    styleUrls: ['./select-filter.styles.scss'],
})
export class SelectFilterComponent {
    @Input() filter: SelectFilter;
    @Input() show = false;
    @Input() context = `table-filter-${nextContext++}`;

    onSelectionChanged({ value }: MatSelectChange): void {
        this.filter.changeValue(value);
    }
}
